<template>
  <div class="welfare-new-member-detail">
    <div class="welfare-new-member-detail-content">
      <ym-img class="welfare-new-member-detail-content-bg"
              :src="require('@/assets/img/welfare/bg.png')"
      />
      <div class="welfare-new-member-detail-content-choose-hint">
        根据孩子年龄段激发兴趣，请选择三个礼包中的一个
      </div>
      <div class="welfare-new-member-detail-content-gift">
        <div class="welfare-new-member-detail-content-gift-title"
             :class="{
               'title-0': currGift === 0,
               'title-1': currGift === 1,
               'title-2': currGift === 2,
             }"
        >
          <div class="welfare-new-member-detail-content-gift-title-item"
               v-ym-report:NEWGIFT2021_SWITCH_CLICK="{ name: '通识启蒙' }"
               @click="handleClickGiftTitle(0)"
          ></div>
          <div class="welfare-new-member-detail-content-gift-title-item"
               v-ym-report:NEWGIFT2021_SWITCH_CLICK="{ name: '能力提升' }"
               @click="handleClickGiftTitle(1)"
          ></div>
          <div class="welfare-new-member-detail-content-gift-title-item"
               v-ym-report:NEWGIFT2021_SWITCH_CLICK="{ name: '成长规划' }"
               @click="handleClickGiftTitle(2)"
          ></div>
        </div>
        <div class="welfare-new-member-detail-content-gift-info"
             :class="{
               'info-0': currGift === 0,
               'info-1': currGift === 1,
               'info-2': currGift === 2,
             }"
        ></div>
      </div>
    </div>
    <div class="welfare-new-member-detail-receive-action"
         v-ym-report:NEWGIFT2021_GET_CLICK=""
         @click="handleJoinExperienceVip"
    >
      一键领取
    </div>

    <receive-popup :show.sync="showReceivePopup"
                   :need-mobile="render.needMobile"
                   @submit-action="handleReceivePopupClose"
    />
    <result-popup :show.sync="showResultPopup"
                  :status="result.status"
                  :is-received="result.isReceived"
                  :is-new-member="isNewMember"
                  :gift-index="currGift"
                  @back-app="handleBackToApp"
    />
  </div>
</template>

<script>
  import { decorator, before } from 'ym-reporter-vue';
  import ReceivePopup from '@/pages/WelfareNewMember/components/ExperienceVipReceivePopup';
  import ResultPopup from '@/pages/WelfareNewMember/components/ExperienceVipReceiveResultPopup';
  import { newMemberDetail, receiveWelfareNewMemberGift } from '@/services/welfare';
  import { loginRegisterWithMobile } from '@/services/app';
  import { isAppWebView, projectJump } from '@/utils';

  export default {
    name: 'MillionReadExperienceVip',
    metaInfo: {},
    components: {
      ReceivePopup,
      ResultPopup,
    },
    data() {
      return {
        currGift: 0,
        batchIdList: [],
        render: {
          needMobile: true,
        },
        receiveDisabled: false,

        mobile: '',
        smsCode: '',
        isNewMember: false,

        showReceivePopup: false,
        showResultPopup: false,

        showWelfarePopup: false,
        result: {
          status: '',
          isReceived: false,
          needReport: false,
        },

        showExperiencePopup: false,
      };
    },
    computed: {
      query() {
        return this.$route.query ? this.$route.query : {};
      },
      inAppWebView() {
        return isAppWebView();
      },
      activityType() {
        return this.$route.query && this.$route.query.activityType
          ? this.$route.query.activityType : 'notExist';
      },
    },
    methods: {
      handleClickGiftTitle(index) {
        this.currGift = index;
      },
      handleCheckFn(fn, params) {
        const isFn = window[fn] && typeof window[fn] === 'function';
        const hasParams = typeof params !== 'undefined';
        if (!this.inAppWebView || !isFn) return;
        if (hasParams) {
          window[fn](params);
        } else {
          window[fn]();
        }
      },
      handleDismissWebview() {
        this.handleCheckFn('dismissWebview');
      },
      handleLoginSuccess(token) {
        this.handleCheckFn('loginSuccess', token);
      },
      @decorator(before(function () {
        this.$reporter.report('MILLION_EXVIP_GET_SUCCESS');
      }))
      handleHideAdvertPopup() {
        this.handleCheckFn('hideAdvertPopup');
      },
      async fetchData() {
        const data = await newMemberDetail(this.query);
        this.render = Object.assign(this.render, data.render);
        this.batchIdList = data.batchIdList;
      },
      handleBackToApp() {
        if (!this.inAppWebView) {
          projectJump({
            name: 'MillionReadSelect',
          });
          return;
        }
        this.handleDismissWebview();
      },
      handleReportRegisterData() {},
      @decorator(before(function () {
        this.$reporter.report('NEWGIFT2021_GET_SUCCESS', {
          type: this.isNewMember ? '注册' : '登录',
        });
      }))
      async handleReceiveWelfareGift() {
        try {
          const data = await receiveWelfareNewMemberGift(Object.assign(this.query, {
            id: this.batchIdList[this.currGift],
          }));
          this.handleHideAdvertPopup();
          this.result = data;
          if (data.needReport) {
            this.handleReportRegisterData();
          }
          this.showResultPopup = true;
          this.receiveDisabled = true;
        } catch (e) {
          window.location.reload();
        }
      },
      async handleLogin() {
        const data = await loginRegisterWithMobile({
          type: this.activityType,
          sms_type: 'verify',
          mobile: this.mobile,
          sms_code: this.smsCode,
        });
        this.handleLoginSuccess(data.token);
        this.isNewMember = data.isNewMember;
        this.showReceivePopup = false;
        this.handleReceiveWelfareGift();
      },
      handleResetUserInfo(params) {
        this.mobile = params.mobile;
        this.smsCode = params.smsCode;
      },
      async handleReceivePopupClose(params) {
        await this.handleResetUserInfo(params);
        this.handleLogin();
      },
      async handleJoinExperienceVip() {
        if (this.receiveDisabled) return;
        if (this.render.needMobile) {
          this.showReceivePopup = true;
          return;
        }
        this.handleReceiveWelfareGift();
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .welfare-new-member-detail {
    box-sizing: border-box;
    min-height: 100%;
    padding-bottom: 130px;
    background: linear-gradient(225deg, #ffdf00 0%, #ff9500 19%, #ff6f00 100%);
    .img {
      width: 100%;
      display: block;
    }
    &-content {
      box-sizing: border-box;
      position: relative;
      height: 1400px;
      max-width: 750px;
      margin: 0 auto;
      padding-top: 392px;
      &-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1400px;
      }
      &-choose-hint {
        position: relative;
        z-index: 2;
        width: 620px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto @size-base;
        color: #ffe688;
        font-size: 25px;
        font-weight: @font-weight-bold;
        line-height: 1;
        background: #0d8372;
        border-radius: 28px;
      }
      &-gift {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        &-title {
          position: relative;
          z-index: 2;
          display: flex;
          width: 640px;
          height: 270px;
          margin-bottom: 54px;
          &.title-0 {
            background: url('~@/assets/img/welfare/gift_title_01.png');
            background-size: 100% 100%;
          }
          &.title-1 {
            background: url('~@/assets/img/welfare/gift_title_02.png');
            background-size: 100% 100%;
          }
          &.title-2 {
            background: url('~@/assets/img/welfare/gift_title_03.png');
            background-size: 100% 100%;
          }
          &-item {
            flex: 1;
          }
        }
        &-info {
          position: relative;
          z-index: 2;
          width: 666px;
          height: 514px;
          &.info-0 {
            background: url('~@/assets/img/welfare/gift_info_01.png');
            background-size: 100% 100%;
          }
          &.info-1 {
            background: url('~@/assets/img/welfare/gift_info_02.png');
            background-size: 100% 100%;
          }
          &.info-2 {
            background: url('~@/assets/img/welfare/gift_info_03.png');
            background-size: 100% 100%;
          }
        }
      }
    }
    &-receive-action {
      width: 464px;
      height: 88px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto @size-extra-small;
      color: #ff5d00;
      font-size: @font-size-large;
      font-weight: @font-weight-strong;
      line-height: 1;
      background: linear-gradient(180deg, #fffcf3 0%, #ffe291 100%);
      box-shadow: 0 8px 16px 0 rgba(255, 93, 0, 0.5);
      border-radius: 44px;
    }
  }
</style>
